"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyBorderImage = exports.stringifyTopRightBottomLeft = exports.findEndOfClosure = exports.splitLayers = exports.StylableShorthands = void 0;
var tslib_1 = require("tslib");
var property_parser_1 = require("./utils/css-utils/property-parser");
var stylable_site_vars_1 = require("./stylable-site-vars");
var EMPTY_BORDER_IMAGE = {
    'border-image-source': 'none',
    'border-image-slice': '100%',
    'border-image-width': '1',
    'border-image-outset': '0',
    'border-image-repeat': 'stretch',
};
var StylableShorthands = /** @class */ (function () {
    function StylableShorthands(evalDeclarationValue) {
        if (evalDeclarationValue === void 0) { evalDeclarationValue = stylable_site_vars_1.DEFAULT_EVAL_DECLARATION_VALUE; }
        this.evalDeclarationValue = evalDeclarationValue;
    }
    StylableShorthands.prototype.expandDeclaration = function (_a, overrides, includeInitialValues, disableBackgroundShorthand) {
        var _b;
        var prop = _a.prop, value = _a.value;
        if (includeInitialValues === void 0) { includeInitialValues = true; }
        if (disableBackgroundShorthand === void 0) { disableBackgroundShorthand = false; }
        var evaluatedValue = this.evalDeclarationValue(value, overrides);
        if (prop === 'border-image') {
            return this.expandBorderImage(evaluatedValue);
        }
        try {
            var expanded = (0, property_parser_1.expandShorthandCssProp)(prop, evaluatedValue, includeInitialValues, disableBackgroundShorthand);
            if (prop !== 'border') {
                return expanded;
            }
            return tslib_1.__assign(tslib_1.__assign({}, expanded), { 'border-image-source': 'none' });
        }
        catch (_c) {
            return _b = {}, _b[prop] = evaluatedValue, _b;
        }
    };
    StylableShorthands.prototype.getShorthandProps = function (propName) {
        return (0, property_parser_1.getShorthandComputedProps)(propName);
    };
    StylableShorthands.prototype.expandBorderImage = function (value) {
        var result = tslib_1.__assign({}, EMPTY_BORDER_IMAGE);
        value = value.trim();
        if (value === 'none') {
            return result;
        }
        var sourcePrefixes = [
            'url',
            'image',
            'image-set',
            'element',
            'cross-fade',
            'linear-gradient',
            'repeating-linear-gradient',
            'radial-gradient',
            'repeating-radial-gradient',
        ];
        if (!sourcePrefixes.some(function (prefix) { return value.startsWith(prefix + '('); })) {
            return result;
        }
        var firstParens = value.indexOf('(') + 1;
        var endOfSource = findEndOfClosure(value.slice(firstParens));
        var afterSourceIndex = firstParens + endOfSource + 1;
        result['border-image-source'] = value.slice(0, firstParens + endOfSource + 1);
        if (value.charAt(afterSourceIndex) !== ' ') {
            if (value.charAt(afterSourceIndex) !== '') {
                result = tslib_1.__assign({}, EMPTY_BORDER_IMAGE);
            }
            return result;
        }
        var afterSource = value.slice(afterSourceIndex + 1);
        // const imageRegex = /^(?<slice>((\s?fill\s?)|(\s?\d+[%\w]*\s?)){1,4})?(?<widthOutset>(\s?\/\s?(\d+[%\w]*\s?){1,4})(\s?\/\s?(\d+[%\w]*\s?){1,4})?)?(?<repeat>((\s?stretch\s?)|(\s?repeat\s?)|(\s?round\s?)|(\s?space\s?)){1,2})?$/;
        var imageRegex = /^(((\s?fill\s?)|(\s?\d+[%\w]*\s?)){1,4})?((\s?\/\s?(\d+[%\w]*\s?){1,4})(\s?\/\s?(\d+[%\w]*\s?){1,4})?)?(((\s?stretch\s?)|(\s?repeat\s?)|(\s?round\s?)|(\s?space\s?)){1,2})?$/;
        var imageMatch = afterSource.match(imageRegex);
        if (!imageMatch) {
            result = tslib_1.__assign({}, EMPTY_BORDER_IMAGE);
            return result;
        }
        var sliceValue = imageMatch[1];
        var widthOutsetValue = imageMatch[5];
        var repeatValue = imageMatch[10];
        if (sliceValue) {
            result['border-image-slice'] = sliceValue.trim();
        }
        if (widthOutsetValue) {
            var widthOutsetArr = widthOutsetValue.trim().split('/').slice(1);
            if (widthOutsetArr[0]) {
                result['border-image-width'] = widthOutsetArr[0].trim();
            }
            if (widthOutsetArr[1]) {
                result['border-image-outset'] = widthOutsetArr[1].trim();
            }
        }
        if (repeatValue) {
            result['border-image-repeat'] = repeatValue.trim();
        }
        return result;
    };
    return StylableShorthands;
}());
exports.StylableShorthands = StylableShorthands;
function splitLayers(value, seperator) {
    if (seperator === void 0) { seperator = ','; }
    var layers = [];
    var prevIndex = 0;
    var closureLevel = 0;
    for (var i = 0; i < value.length; i++) {
        switch (value.charAt(i)) {
            case '(':
                closureLevel++;
                break;
            case ')':
                if (closureLevel === 0) {
                    throw new Error('Invalid value: ' + value);
                }
                closureLevel--;
                break;
            case seperator:
                if (closureLevel === 0) {
                    layers.push(value.slice(prevIndex, i).trim());
                    prevIndex = i + 1;
                }
                break;
        }
    }
    layers.push(value.slice(prevIndex).trim());
    return layers;
}
exports.splitLayers = splitLayers;
function findEndOfClosure(value) {
    var closureLevel = 1;
    for (var i = 0; i < value.length; i++) {
        var currChar = value.charAt(i);
        switch (currChar) {
            case '(':
                closureLevel++;
                break;
            case ')':
                closureLevel--;
                break;
        }
        if (closureLevel === 0) {
            return i;
        }
    }
    return value.length - 1;
}
exports.findEndOfClosure = findEndOfClosure;
function stringifyTopRightBottomLeft(value) {
    if (!value) {
        return undefined;
    }
    if (typeof value === 'string') {
        return value;
    }
    var top = value.top, right = value.right, bottom = value.bottom, left = value.left;
    if (top === right && right === bottom && bottom === left) {
        return top;
    }
    if (top === bottom && right === left) {
        return "".concat(top, " ").concat(right);
    }
    if (right === left) {
        return "".concat(top, " ").concat(right, " ").concat(bottom);
    }
    return "".concat(top, " ").concat(right, " ").concat(bottom, " ").concat(left);
}
exports.stringifyTopRightBottomLeft = stringifyTopRightBottomLeft;
function stringifyBorderImage(value) {
    if (!value) {
        return undefined;
    }
    if (typeof value === 'string') {
        return value;
    }
    if (value['border-image-source'] === undefined || value['border-image-source'] === 'none') {
        return 'none';
    }
    var stringifiedBorderImage = "".concat(value['border-image-source']);
    stringifiedBorderImage += " ".concat(value['border-image-slice'] || EMPTY_BORDER_IMAGE['border-image-slice']);
    stringifiedBorderImage += " / ".concat(value['border-image-width'] || EMPTY_BORDER_IMAGE['border-image-width']);
    stringifiedBorderImage += " ".concat(value['border-image-repeat'] || EMPTY_BORDER_IMAGE['border-image-repeat']);
    return stringifiedBorderImage;
}
exports.stringifyBorderImage = stringifyBorderImage;
//# sourceMappingURL=stylable-shorthands.js.map